import { Typographies } from '@/theme';
import Colors from '@/theme/constants/Colors';
import { JTextFieldBaseProps } from '@atoms/JTextFieldBase';
import { IconSize } from '@constants';
import { FormControl, MenuItem, Select, styled } from '@mui/material';

export const FromControlStyled = styled(FormControl)<JTextFieldBaseProps>(
  ({
    theme,
    noBorder,
    attr: { whiteBg } = {},
    fullWidth,
    helpertextinside: helperTextInside,
  }) => ({
    maxWidth: fullWidth ? 'auto' : 200,
    width: fullWidth ? '100%' : 200,
    height: '54px',

    '&:hover .MuiInputBase-root::before, & .MuiInputBase-root::after': {
      borderBottom: 'none',
    },

    '&:hover .MuiInputBase-root::before, &:hover .MuiInputBase-root::after': {
      borderBottom: 'none',
    },
    '& .MuiSelect-select': {
      paddingTop: '21px',
      paddingBottom: '4px',
    },

    // Add helper text as ::after element
    '&::after': {
      content: `"${helperTextInside ?? ''}"`,
      position: 'absolute',
      bottom: 5,
      right: 10,
      color: theme.palette.text.primary, // You can customize the color
      fontSize: '12px', // You can customize the font size
    },

    '& .MuiFilledInput-root': {
      '&:before': {
        borderBottom: 'none',
      },

      borderRadius: theme.spacing(1),

      fontSize: Typographies.FONT_SIZE_INPUTS,
      color: theme.palette.text.primary,
      backgroundColor: whiteBg ? Colors.WHITE : Colors.COLOR_WHITE_2,
    },
    '& .MuiFormLabel-root': {
      color: theme.palette.dark.dark_4,
    },
    '& input:-webkit-autofill': {
      WebkitBoxShadow: `0 0 0px 1000px ${
        whiteBg ? Colors.WHITE : Colors.COLOR_WHITE_2
      } inset`,
    },
  }),
);

export const MenuItemStyled = styled(MenuItem)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  '&.Mui-selected': {
    color: theme.palette.primary.main,
  },

  '&:not(:first-child)': {
    borderTop: `${theme.typography.pxToRem(0.2)} solid ${
      theme.palette.white.light
    }`,
  },
}));

export const SelectStyled = styled(Select)(({ theme }) => ({
  '& svg': {
    height: `${IconSize.sm}px !important`,
    width: `${IconSize.sm}px !important`,
  },
}));
